export default __webpack_public_path__ + "static/media/82.86829e72.png";